import { Box, Skeleton } from "@mui/material"

export const SliderSkeleton = () => {
  return (
 <Box sx={{width:"100%",}}> 
   <Skeleton variant="rectangular" sx={{width:"100%", height:"300px"}} />
 </Box>
  )
}
